import { combineEpics } from 'redux-observable';

import {
	handleCityChangeEpic,
	handleMrtLineChangeEpic,
	handleQueryStringEpic,
} from 'actions/filter';

import {
	openMessageModalEpic,
	closeMessageModalEpic,
	handleForgetVerifyModalEpic,
	handleLoginModalEpic,
} from 'actions/modal';

import { errorHandleEpic } from 'actions/alert';
import { updateSongKeywordEpic } from 'actions/song';
import {
	updateUserProfessionKeywordEpic,
	updateUserInterestKeywordEpic,
	updateUserCareerKeywordEpic,
	syncUserSettingLocalStorageEpic,
} from 'actions/bind';
import { updateBookingMonthEpic } from './booking';

export const rootEpic = combineEpics(
	handleCityChangeEpic,
	handleMrtLineChangeEpic,
	handleQueryStringEpic,
	openMessageModalEpic,
	closeMessageModalEpic,
	handleForgetVerifyModalEpic,
	handleLoginModalEpic,
	errorHandleEpic,
	updateSongKeywordEpic,
	updateUserProfessionKeywordEpic,
	updateUserInterestKeywordEpic,
	updateUserCareerKeywordEpic,
	updateBookingMonthEpic,
	syncUserSettingLocalStorageEpic,
);



// WEBPACK FOOTER //
// ./src/actions/epics.js